export function getVisibleParagraphsCount(text: string, count: number) {
    return text
        .slice(0, Math.min(text.length, count))
        .split("\n")
        .filter((str) => !!str.trim()).length
}
